import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import Rowbox from '../Common/Rowbox'
import Header from '../Common/Header'
import {
  DECORATION_EVALUATE,
  APPRAISE_LIST_PATH,
  THEME_WHITE_RED,
  THEME_WHITE_PINK,
  THEME_WHITE_GREEN,
  THEME_WHITE_GOLD,
  THEME_BLACK_GOLD,
  THEME_TOP_WEDDING
} from '@constant'
import Item from './Item'
import { dGet } from '@core/utils'
import Store from './store'
import More from '../Common/More'
import { getEvaluateColor } from '@components/LocalMerchant/Decoration/util'

@inject('decorationStore')
@observer
class Tag extends Component {
  onChange = () => {
    this.props.store.changeTag(this.props.id)
  }

  render() {
    const {
      id,
      name,
      active,
      decorationStore: { theme }
    } = this.props
    const {
      tabBg,
      tabSelectedBg,
      tabSelectedTextColor,
      tabTextColor
    } = getEvaluateColor(theme)
    const isActive = id == active

    return (
      <span
        style={{
          background: isActive ? tabSelectedBg : tabBg,
          color: isActive ? tabSelectedTextColor : tabTextColor,
          height: 30,
          borderRadius: 15,
          marginRight: 6,
          marginBottom: 10,
          display: 'inline-block',
          lineHeight: '30px',
          textAlign: 'center',
          padding: '0 10px'
        }}
        onClick={this.onChange}
      >
        {name}
      </span>
    )
  }
}

const getColor = theme => {
  if (theme == THEME_WHITE_RED) {
    return '#F83244'
  }

  if (
    theme == THEME_WHITE_GOLD ||
    theme == THEME_BLACK_GOLD ||
    theme == THEME_TOP_WEDDING
  ) {
    return '#E8B45E'
  }

  if (theme == THEME_WHITE_PINK) {
    return '#FF7894'
  }

  if (theme == THEME_WHITE_GREEN) {
    return '#98CE64'
  }

  return '#48B1FF'
}

@inject('decorationStore')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
  }

  componentDidMount() {
    this.store.getCommentTagList()
    this.store.getCommentList()
  }

  render() {
    const {
      comment,
      commentTagList,
      currentCommentTag,
      changeTag,
      totalAll
    } = this.store
    const {
      decorationStore: { mode, themeConfig, homeData, theme }
    } = this.props
    let { list } = comment
    list = list || []

    return (
      <Rowbox
        type={DECORATION_EVALUATE}
        store={this.props.decorationStore}
        style={{ height: 'auto', flexDirection: 'column' }}
        vCenter={false}
      >
        <Header
          title={<span>用户评价（{totalAll}）</span>}
          content={
            <span style={{ color: getColor(theme) }}>
              {totalAll > 0 ? (
                <span>
                  好评率{dGet(homeData, 'merchant_comment.good_rate') * 100 +
                    '%'}
                </span>
              ) : (
                <span>暂无评价</span>
              )}
            </span>
          }
          contentStyle={{ color: themeConfig['text'] }}
        />

        {mode === 'editable' && (
          <div style={{ padding: '8px 0' }}>
            该模块数据来自用户生成，无法配置
          </div>
        )}
        {mode === 'preview' && (
          <>
            <div
              style={{
                padding: '10px 0 0'
              }}
            >
              {[{ name: '全部', id: '0' }, ...commentTagList].map(
                (item, index) => (
                  <Tag
                    key={index}
                    active={currentCommentTag}
                    changeTag={changeTag}
                    {...item}
                    store={this.store}
                  />
                )
              )}
            </div>

            <div>{list.map(item => <Item key={item.id} {...item} />)}</div>
          </>
        )}

        {mode === 'preview' &&
          totalAll > list.length && (
            <More link={`${APPRAISE_LIST_PATH}?tab=2`} text="更多评价" />
          )}
      </Rowbox>
    )
  }
}
